import React from 'react';
import { Link } from 'react-router-dom';
import Logo from '../components/Logo';

const Contact = () => {
	return (
		<div className="min-h-screen bg-gray-50">
			<header className="bg-white shadow-sm border-b border-gray-200">
				<div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-4">
					<div className="flex items-center justify-between">
						<Link to="/">
							<Logo showText={true} width={50} height={50} />
						</Link>
						<Link
							to="/"
							className="text-gray-700 hover:text-blue-600 transition-colors font-medium"
						>
							Back to Home
						</Link>
					</div>
				</div>
			</header>

			<div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
				<div className="bg-white rounded-lg shadow-lg p-8 md:p-12">
					<h1 className="text-4xl font-bold text-gray-900 mb-4">Contact Us</h1>
					<p className="text-gray-600 mb-10 text-lg">
						Have a question, feedback, or want to learn more about iVault? We’d love to hear from you. Choose the option that fits best below.
					</p>

					<div className="prose prose-lg max-w-none">
						<section className="mb-10">
							<h2 className="text-2xl font-semibold text-gray-900 mb-4">Get in Touch</h2>
							<div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-6">
								<div className="bg-gray-50 p-6 rounded-lg border border-gray-100">
									<h3 className="font-semibold text-gray-900 mb-2">General Inquiries</h3>
									<p className="text-gray-700 text-sm mb-1"><strong>Email:</strong> hello@ivault.com</p>
									<p className="text-gray-600 text-sm">Questions about iVault, pricing, or how we can help your startup or fund. We typically respond within 1–2 business days.</p>
								</div>
								<div className="bg-gray-50 p-6 rounded-lg border border-gray-100">
									<h3 className="font-semibold text-gray-900 mb-2">Support</h3>
									<p className="text-gray-700 text-sm mb-1"><strong>Email:</strong> support@ivault.com</p>
									<p className="text-gray-600 text-sm">Technical issues, account questions, or help using the platform. Include your account email and a short description of the issue.</p>
								</div>
								<div className="bg-gray-50 p-6 rounded-lg border border-gray-100">
									<h3 className="font-semibold text-gray-900 mb-2">Careers</h3>
									<p className="text-gray-700 text-sm mb-1"><strong>Email:</strong> careers@ivault.com</p>
									<p className="text-gray-600 text-sm">Interested in joining the team? Send your resume and a note with subject line “Careers – [Role]”. See our <Link to="/careers" className="text-blue-600 hover:underline">Careers page</Link> for open roles.</p>
								</div>
								<div className="bg-gray-50 p-6 rounded-lg border border-gray-100">
									<h3 className="font-semibold text-gray-900 mb-2">Privacy & Legal</h3>
									<p className="text-gray-700 text-sm mb-1"><strong>Email:</strong> privacy@ivault.com</p>
									<p className="text-gray-600 text-sm">Data privacy, compliance, or legal inquiries. For policy text, see our <Link to="/privacy" className="text-blue-600 hover:underline">Privacy Policy</Link> and <Link to="/terms" className="text-blue-600 hover:underline">Terms of Service</Link>.</p>
								</div>
							</div>
							<div className="bg-gray-50 p-6 rounded-lg border border-gray-100">
								<h3 className="font-semibold text-gray-900 mb-2">Office</h3>
								<p className="text-gray-700"><strong>Address:</strong> Techpuram</p>
								<p className="text-gray-600 text-sm mt-2">We’re a distributed team, but you can reach us at the above email addresses any time.</p>
							</div>
						</section>

						<section className="mb-10">
							<h2 className="text-2xl font-semibold text-gray-900 mb-4">What to Expect</h2>
							<ul className="list-disc pl-6 text-gray-700 space-y-2">
								<li><strong>Response time:</strong> We aim to reply to all messages within 1–2 business days. Support requests may be faster during business hours.</li>
								<li><strong>Sales or demos:</strong> Mention that you’d like a demo or a call in your email, and we’ll schedule something that works for you.</li>
								<li><strong>Feedback:</strong> Product feedback and feature requests are welcome. We read everything and use it to prioritize what we build next.</li>
							</ul>
						</section>

						<section className="mb-8">
							<h2 className="text-2xl font-semibold text-gray-900 mb-4">Quick Links</h2>
							<p className="text-gray-700 mb-4">
								You might also find what you need here:
							</p>
							<ul className="list-none space-y-2">
								<li><Link to="/" className="text-blue-600 hover:underline">Home</Link></li>
								<li><Link to="/about" className="text-blue-600 hover:underline">About iVault</Link></li>
								<li><Link to="/blog" className="text-blue-600 hover:underline">Blog</Link></li>
								<li><Link to="/careers" className="text-blue-600 hover:underline">Careers</Link></li>
								<li><Link to="/privacy" className="text-blue-600 hover:underline">Privacy Policy</Link></li>
								<li><Link to="/terms" className="text-blue-600 hover:underline">Terms of Service</Link></li>
							</ul>
						</section>
					</div>
				</div>
			</div>
		</div>
	);
};

export default Contact;
